import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { singletonHook } from 'react-singleton-hook';

import { IAthleteGender } from '@interfaces/lookups';
import { handleGetAthleteGenders } from '@store/features/athleteGenders/actions';
import {
  athleteGendersErrorSelector,
  athleteGendersIsLoadingSelector,
  athleteGendersIsReadySelector,
  athleteGendersSelector,
} from '@store/features/athleteGenders/selectors';
import { userDataSelector } from '@store/features/auth/user/selectors';
import useDispatch from '@store/hooks/useDispatch';

import useFetchLookupData from './useFetchLookupData';

const useAthleteGenders = (): IAthleteGender[] => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const data = useSelector(athleteGendersSelector);
  const isLoading = useSelector(athleteGendersIsLoadingSelector);
  const isReady = useSelector(athleteGendersIsReadySelector);
  const error = useSelector(athleteGendersErrorSelector);
  const user = useSelector(userDataSelector);

  const handleFetch = useCallback(() => {
    user?.showGender && dispatch(handleGetAthleteGenders());
  }, [dispatch, user]);

  useFetchLookupData({
    isReady,
    isLoading,
    error: error && t('errors.athleteGendersError'),
    handleFetch,
  });

  return data;
};

export default singletonHook([], useAthleteGenders);
